import { languageMap } from ".."

languageMap.sln = languageMap["solution-file"] = {
	comments: {
		line: "#",
	},
}
